import PropTypes from 'prop-types';
import React from "react";

const AutocompleteResultItem = ({suggestionItem, onSelect, isSelected}) => {
    const mainText = suggestionItem?.placePrediction?.structuredFormat?.mainText?.text || "";
    const secondaryText = suggestionItem?.placePrediction?.structuredFormat?.secondaryText?.text || "";
    const matchOffset = suggestionItem?.placePrediction?.structuredFormat?.mainText?.matches?.[0]?.endOffset || 0;
    //If we enable queryPrediction then handle also suggestionItem?.queryPrediction

    return (
        <div
            className={`autocomplete-item ${isSelected ? "selected" : ""}`}
            onClick={() => onSelect(mainText, suggestionItem?.placePrediction?.placeId)}
        >
            {/* Apply different styles to the matching portion */}
            <span className="autocomplete-result-item-main-text-matched">
                {mainText.substring(0, matchOffset)}
            </span>
            <span className="autocomplete-result-item-main-text">
                {mainText.substring(matchOffset)}
            </span>
            <span className="autocomplete-result-item-secondary-text">
                , {secondaryText}
            </span>
        </div>
    );
};

AutocompleteResultItem.propTypes = {
    suggestionItem: PropTypes.object,
    onSelect: PropTypes.func,
    isSelected: PropTypes.bool
}
export default AutocompleteResultItem;
